import React, { forwardRef, ComponentProps } from 'react';

import Icon, { IconWithRender, generateRenderedIcon } from './Icon';
import { VIEWBOXES } from '../consts';
import { IconVariations } from '../useIconVariation';

const draw16px =
  'M15.749 8a.749.749 0 0 1-.22.53l-2.59 2.59a.748.748 0 0 1-1.06 0 .754.754 0 0 1 0-1.06l1.31-1.31h-4.44v4.44l1.31-1.31a.737.737 0 0 1 1.06 0 .754.754 0 0 1 0 1.06l-2.59 2.59a.767.767 0 0 1-.53.22.786.786 0 0 1-.53-.22l-2.59-2.59a.754.754 0 0 1 0-1.06.737.737 0 0 1 1.06 0l1.31 1.31V8.752h-4.44l1.31 1.31a.754.754 0 0 1 0 1.06.767.767 0 0 1-.53.22.786.786 0 0 1-.53-.22l-2.59-2.59a.754.754 0 0 1 0-1.06l2.59-2.59a.737.737 0 0 1 1.06 0 .754.754 0 0 1 0 1.06l-1.31 1.31h4.44v-4.44l-1.31 1.31a.75.75 0 0 1-1.06-1.06l2.59-2.59a.745.745 0 0 1 1.06 0l2.59 2.59a.754.754 0 0 1 0 1.06.767.767 0 0 1-.53.22.786.786 0 0 1-.53-.22l-1.31-1.31v4.44h4.44l-1.31-1.31a.754.754 0 0 1 0-1.06.745.745 0 0 1 1.06 0l2.59 2.59a.749.749 0 0 1 .22.528Z';
const draw24px =
  'M21.53,12.53l-2.59,2.6a.77.77,0,0,1-.53.21.76.76,0,0,1-.53-.21.75.75,0,0,1,0-1.07l1.31-1.31H12.75v6.44l1.31-1.31a.75.75,0,0,1,1.06,1.06l-2.59,2.59a.74.74,0,0,1-.53.22.71.71,0,0,1-.53-.22L8.88,18.94a.74.74,0,0,1,0-1.06.75.75,0,0,1,1.06,0l1.31,1.31V12.75H4.81l1.31,1.31a.77.77,0,0,1,0,1.07.77.77,0,0,1-.53.21.74.74,0,0,1-.53-.21l-2.59-2.6a.74.74,0,0,1,0-1.06L5.06,8.88A.75.75,0,0,1,6.12,9.94L4.81,11.25h6.44V4.81L9.94,6.13A.75.75,0,0,1,8.88,5.06l2.59-2.59a.77.77,0,0,1,1.06,0l2.59,2.59a.77.77,0,0,1,0,1.07.77.77,0,0,1-.53.21.74.74,0,0,1-.53-.21L12.75,4.81v6.44h6.44L17.88,9.94a.74.74,0,0,1,0-1.06.75.75,0,0,1,1.06,0l2.59,2.59A.75.75,0,0,1,21.53,12.53Z';

const icons: IconVariations = {
  _16: { d: draw16px, viewBox: VIEWBOXES._16 },
  _24: { d: draw24px, viewBox: VIEWBOXES._24 },
};

const MoveIcon = forwardRef<SVGSVGElement, ComponentProps<typeof Icon>>(
  generateRenderedIcon(icons, 'move'),
) as IconWithRender;

MoveIcon.displayName = 'MoveIcon';
MoveIcon.propTypes = Icon.propTypes;
MoveIcon.renderIcon = (props) => <MoveIcon {...props} />;
export default MoveIcon;
